export default __webpack_public_path__ + "static/media/alailogo.6fed4878.png";